var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DDQ, getOnetimePrice } from '@api/utils';
import { findOneById } from '@api/services/tariff';
import { ProductsService } from '@api/services/products';
import { BasketAssistant } from '@api/services/basket';
import { entityDecode } from '@api/utils';
import config from '@api/config';
var TrackingCheckout = /*@__PURE__*/ (function () {
    function TrackingCheckout() {
        this.pageType = 'product detail';
    }
    TrackingCheckout.prototype.setShippingMethod = function (shippingMethod) {
        this.shippingMethod = shippingMethod;
        return this;
    };
    TrackingCheckout.prototype.setShippingPrice = function (shippingPrice) {
        this.shippingPrice = shippingPrice;
        return this;
    };
    TrackingCheckout.prototype.setPaymentMethodOnce = function (paymentMethodOnce) {
        this.paymentMethodOnce = paymentMethodOnce;
        return this;
    };
    TrackingCheckout.prototype.setPaymentMethodRecurring = function (paymentMethodRecurring) {
        this.paymentMethodRecurring = paymentMethodRecurring;
        return this;
    };
    TrackingCheckout.prototype.setNumberPortability = function (numberPortability) {
        this.numberPortability = numberPortability;
        return this;
    };
    TrackingCheckout.prototype.setOrderId = function (orderId) {
        this.orderId = orderId;
        return this;
    };
    TrackingCheckout.prototype.setZipCode = function (zipcode) {
        this.zipcode = zipcode;
        return this;
    };
    TrackingCheckout.prototype.setStep = function (step) {
        this.step = step;
        return this;
    };
    TrackingCheckout.prototype.setName = function (name) {
        this.name = name;
        return this;
    };
    TrackingCheckout.prototype.setPageType = function (pageType) {
        this.pageType = pageType;
        return this;
    };
    TrackingCheckout.prototype.setStatus = function (status) {
        this.status = status;
        return this;
    };
    TrackingCheckout.prototype.setPartnerShopID = function (partnerShopID) {
        this.partnerShopID = partnerShopID;
        return this;
    };
    TrackingCheckout.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = {
                            tealiumUseDCF: true,
                            customTracking: true,
                            lineOfCustomer: 'enterprise',
                            businessTransactionType: 'newcontract',
                            siteStructure: [
                                'geschaeftskunden',
                                'handys, tablets & internet',
                                this.pageType
                            ],
                            loginStatus: (-1 != document.cookie.indexOf('MDDKeks')) ? 'logged in' : 'not logged in',
                            siteArea: 'enterprise-mobility',
                            platformType: 'responsive',
                            pageType: this.pageType
                        };
                        return [4 /*yield*/, this.getOForm()];
                    case 1:
                        _a.oForm = _b.sent();
                        return [4 /*yield*/, this.getOOrder()];
                    case 2:
                        data = (_a.oOrder = _b.sent(),
                            _a.partnerShopID = this.partnerShopID,
                            _a);
                        if (config.TEALIUM_ENVIRONMENT) {
                            data.tealiumEnvironment = 'autotest';
                        }
                        return [2 /*return*/, data];
                }
            });
        });
    };
    TrackingCheckout.prototype.getOOrder = function () {
        return __awaiter(this, void 0, void 0, function () {
            var items, position, oOrder, commissioningIds, _a, _b, _i, item, basketItem, tariff, tariffEntity, article, articleEntity, _c, _d, component, articleId, articleName, articlePrice, productCategory, tariffId, tariffName, tariffPrice, duration, productLine, separator, usedOptions, basketVoucher;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        items = _e.sent();
                        position = 1;
                        oOrder = {
                            aPropositions: [],
                            aProducts: []
                        };
                        commissioningIds = [];
                        _a = [];
                        for (_b in items)
                            _a.push(_b);
                        _i = 0;
                        _e.label = 2;
                    case 2:
                        if (!(_i < _a.length))
                            return [3 /*break*/, 13];
                        item = _a[_i];
                        basketItem = items[item];
                        tariff = void 0;
                        tariffEntity = void 0;
                        article = void 0;
                        articleEntity = void 0;
                        _c = 0, _d = basketItem.offer.components;
                        _e.label = 3;
                    case 3:
                        if (!(_c < _d.length))
                            return [3 /*break*/, 8];
                        component = _d[_c];
                        if (!(component.type === 'tariffMobile'))
                            return [3 /*break*/, 5];
                        tariff = component;
                        return [4 /*yield*/, findOneById(component.refId)];
                    case 4:
                        tariffEntity = _e.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        article = component;
                        return [4 /*yield*/, ProductsService.findOneById(component.refId)];
                    case 6:
                        articleEntity = _e.sent();
                        _e.label = 7;
                    case 7:
                        _c++;
                        return [3 /*break*/, 3];
                    case 8:
                        articleId = 'simonly';
                        articleName = '';
                        articlePrice = void 0;
                        productCategory = 'tariff';
                        if (articleEntity) {
                            articleId = articleEntity.getSAPId();
                            articleName = article.internalLabel.replace(/[^a-zA-Z0-9 \- ]/g, "");
                            articlePrice = (getOnetimePrice(article.prices) * basketItem.amount).toFixed(2);
                            productCategory = 'bundle';
                        }
                        tariffId = tariffEntity.id;
                        tariffName = tariff.internalLabel;
                        tariffPrice = ((basketItem.offer.getMonthlyPrice() - basketItem.offer.getMonthlyOptionsSum()) * basketItem.amount).toFixed(2);
                        duration = basketItem.offer.getMinimumTerm();
                        commissioningIds.push(tariffEntity.getKIASCode());
                        productLine = tariffEntity.subscriptionType;
                        if (productLine === 'voicedata') {
                            productLine = 'voice';
                        }
                        if (articleId !== 'simonly') {
                            oOrder.aProducts.push({
                                name: entityDecode(articleName),
                                type: 'device',
                                sku: articleId + '',
                                priceOnce: articlePrice + '',
                                priceMonthly: '0.00',
                                proposition: position,
                                units: basketItem.amount
                            });
                        }
                        oOrder.aProducts.push({
                            name: entityDecode(tariffName),
                            type: 'tariff',
                            sku: tariffId + '',
                            priceOnce: '0.00',
                            priceMonthly: tariffPrice + '',
                            duration: duration,
                            proposition: position,
                            units: basketItem.amount
                        });
                        separator = ' mit ';
                        if (articleId === 'simonly') {
                            separator = '';
                        }
                        usedOptions = basketItem.offer.getUsedOptions();
                        usedOptions.forEach(function (option) {
                            var optionId = option.id;
                            if (option.description.backendId) {
                                if (option.description.backendId[0].system === "VLUX") {
                                    optionId = option.description.backendId[0].value;
                                }
                            }
                            var type = option.prices[0].value < 0 ? 'discount' : 'service';
                            oOrder.aProducts.push({
                                name: 'Business ' + entityDecode(option.description.label) + '',
                                priceMonthly: option.prices[0].value.toFixed(2) + '',
                                type: type,
                                sku: optionId + '',
                                proposition: position
                            });
                        });
                        basketVoucher = JSON.parse(window.localStorage.getItem("activeVoucher"));
                        if (basketVoucher) {
                            oOrder.aProducts.push({
                                name: String(basketVoucher),
                                priceMonthly: '-50',
                                type: 'discount',
                                sku: String(basketVoucher),
                                proposition: -1,
                                units: 1
                            });
                        }
                        if (!(this.pageType === 'confirmation'))
                            return [3 /*break*/, 10];
                        oOrder.aPropositions.push({
                            id: position,
                            name: entityDecode(tariffName) + separator + entityDecode(articleName),
                            targetAudience: 'enterprise',
                            retention: 'newcontract',
                            type: 'newcontract',
                            productType: 'credit',
                            productLine: productLine,
                            productCategory: productCategory,
                            units: basketItem.amount,
                            shippingMethod: this.shippingMethod,
                            shippingPrice: this.shippingPrice,
                            commissioningID: tariffEntity.getKIASCode()
                        });
                        if (basketVoucher) {
                            window.localStorage.setItem('activeVoucher', null);
                        }
                        return [4 /*yield*/, BasketAssistant.removeAllItems(true)];
                    case 9:
                        _e.sent();
                        window.sessionStorage.removeItem("vfOrderId");
                        window.sessionStorage.removeItem("vfOrderNumberPortability");
                        return [3 /*break*/, 11];
                    case 10:
                        oOrder.aPropositions.push({
                            id: position,
                            name: entityDecode(tariffName) + separator + entityDecode(articleName),
                            targetAudience: 'enterprise',
                            retention: 'newcontract',
                            type: 'newcontract',
                            productType: 'credit',
                            productLine: productLine,
                            productCategory: productCategory,
                            units: basketItem.amount,
                            shippingMethod: this.shippingMethod,
                            shippingPrice: this.shippingPrice
                        });
                        _e.label = 11;
                    case 11:
                        position++;
                        _e.label = 12;
                    case 12:
                        _i++;
                        return [3 /*break*/, 2];
                    case 13:
                        if (this.orderId) {
                            oOrder.orderID = this.orderId;
                            oOrder.shippingMethod = this.shippingMethod;
                            oOrder.shippingPrice = this.shippingPrice;
                            oOrder.paymentMethodOnce = this.paymentMethodOnce;
                            oOrder.paymentMethodRecurring = this.paymentMethodRecurring;
                            oOrder.numberPortability = this.numberPortability;
                            oOrder.zipcode = this.zipcode;
                            // oOrder.commissioningID = commissioningIds.join(',');
                        }
                        return [2 /*return*/, oOrder];
                }
            });
        });
    };
    TrackingCheckout.prototype.getOForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {
                        formStatus: this.status,
                        formStep: this.step,
                        formStepName: this.name,
                        type: 'order funnel',
                        name: 'enterprise NSF funnel'
                    }];
            });
        });
    };
    TrackingCheckout.prototype.track = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return __awaiter(_this, void 0, void 0, function () {
                var _a, _b, _c, listener;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _b = (_a = DDQ).push;
                            _c = ['pageview'];
                            return [4 /*yield*/, this.getData()];
                        case 1:
                            _b.apply(_a, [_c.concat([_d.sent()])]);
                            listener = function () {
                                resolve();
                            };
                            if (!DDQ.on) {
                                resolve();
                                return [2 /*return*/];
                            }
                            DDQ.on('pageview', function () {
                                if (listener) {
                                    listener();
                                }
                                listener = null;
                            });
                            return [2 /*return*/];
                    }
                });
            });
        });
    };
    return TrackingCheckout;
}());
export { TrackingCheckout };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/services/tracking/tracking.checkout.ts
// module id = null
// module chunks = 